import { axiosInstance } from "@/config/axiosInstance";
import type { BreakView } from "@/components/break/types";

const auth = (key: string) => ({
  headers: { authorization: `Bearer ${key}`, "Content-Type": "application/json" },
});

export type TeamLeaderProfile = {
  _id: string;
  name: string;
  email: string;
  employees: { _id: string; name: string; email: string; designation?: string | null }[];
};

export type TeamDayRow = {
  employee: { _id: string; name: string; email: string; designation: string | null };
  attendance: { status: string; hoursWorked: number | null; isLateEntry: boolean } | null;
  leave: { leaveType: string; status: string; isPaid: boolean; isHalfDay: boolean } | null;
  checkedIn: boolean;
  checkinAt: string | null;
  checkoutAt: string | null;
  onBreak: boolean;
  breaks: BreakView[];
  breakCount: number;
  totalBreakSeconds: number;
  totalSeconds: number | null;
};

export type TeamTotalsRow = {
  employee: { _id: string; name: string; email: string };
  breakCount: number;
  totalBreakSeconds: number;
  daysWithBreaks: number;
  averageBreakSeconds: number;
  approvedLeaveDays: number;
};

export type TeamAttendanceRow = {
  employee: { _id: string; name: string; email: string };
  state: "present" | "absent" | "leave" | "holiday" | "unmarked";
  label: string;
  derived: boolean;
  monthToDate: { present: number; absent: number; leave: number };
};

export const getCurrentTeamLeader = (key: string) =>
  axiosInstance
    .get<{ success: boolean; foundTeamLeader: TeamLeaderProfile }>("/teamleader/current", auth(key))
    .then((r) => r.data);

export const getTeamDay = (key: string) => (date: Date) =>
  axiosInstance
    .post<{ success: boolean; date: string; employees: TeamDayRow[] }>("/teamleader/day", { date }, auth(key))
    .then((r) => r.data);

export const getTeamBreakTotals =
  (key: string) => (range: { startDate: Date; endDate: Date }) =>
    axiosInstance
      .post<{ success: boolean; employees: TeamTotalsRow[] }>("/teamleader/breaks/totals", range, auth(key))
      .then((r) => r.data);

export const getTeamAttendance = (key: string) => (date: Date) =>
  axiosInstance
    .post<{ success: boolean; date: string; employees: TeamAttendanceRow[] }>(
      "/teamleader/attendance",
      { date },
      auth(key)
    )
    .then((r) => r.data);
